import { type IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { IconItem as NewIconItem, type IconItemColor } from '@/ui/IconItem/IconItem';

import { Props } from './types';

/**
 * The old API took a raw Tailwind text-color class (e.g. "text-green-600"); the new
 * component takes a semantic color. Map by keyword so existing callers keep working.
 */
const colorClassToSemantic = (colorClass?: string): IconItemColor | undefined => {
  if (!colorClass) return undefined;
  if (/green|emerald|lime|teal/.test(colorClass)) return 'primary';
  if (/blue|sky|cyan|indigo/.test(colorClass)) return 'secondary';
  if (/red/.test(colorClass)) return 'destructive';
  if (/yellow|amber|orange/.test(colorClass)) return 'warning';
  return 'neutral';
};

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const IconItem = ({ label, checked = false, icon, color, children, dataTestId }: Props) => (
  <NewIconItem
    checked={checked}
    label={label}
    icon={icon as IconDefinition | undefined}
    color={colorClassToSemantic(color)}
    dataTestId={dataTestId}>
    {children}
  </NewIconItem>
);

export default IconItem;
